import { IController } from 'angular';
import * as _ from 'lodash';

import { GraduationPlan } from './../../../../../../../../ng2/shared/constants/graduation-plan.constant';
import { WizardUtils } from './../../../../../../../shared/services/wizard-utils/wizard-utils.service';
import { IWizardFilterActionsOptions } from './../../../../../components/wizard-filter-actions/wizard-filter-actions.typings';

export class GradPlansCtrl implements IController {
  static $inject: string[] = ['$scope', 'WizardUtils'];

  public filteredStudents;
  public studentsWithoutGradPlanOrDate;
  public options: IWizardFilterActionsOptions;
  public currentFilter;

  constructor(public $scope, private WizardUtils: WizardUtils) {}

  $onInit(): void {
    this.WizardUtils.startListeningAndLoad(this);
  }

  setUi(): void {
    this.currentFilter = _.last(this.WizardUtils.getCurrentCohortFilter());
    this.filteredStudents = this.WizardUtils.getFilteredFlattenedStudents();
    this.studentsWithoutGradPlanOrDate = this.getStudentsWithNoGradPlanOrDate();
    this.options = {
      columnKeys: ['gradPlan', 'plannedDiplomaType', 'plannedGraduationDate'],
    };
  }

  getStudentsWithNoGradPlanOrDate(): string[] {
    return _.reduce(
      this.filteredStudents,
      (studentIdCollection: string[], student: any) => {
        const { gradPlan, studentId } = student;
        if (
          !gradPlan ||
          gradPlan === GraduationPlan.PLAN_INCOMPLETE.humanName ||
          gradPlan === GraduationPlan.PLAN_IN_PAST.humanName
        )
          studentIdCollection.push(studentId);
        return studentIdCollection;
      },
      [],
    );
  }
}
